module.exports = __webpack_public_path__ + "static/media/derry-bros.879959ad.png";